module.exports = __webpack_public_path__ + "static/img/certificate-4.56c9f6b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/certificate-4.png
// module id = 5fIq
// module chunks = 1